import React, { useState } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import { FieldMessage } from '@atlassian/jira-issue-create-commons/src/common/ui/field-message/index.tsx';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import { withFormField } from '@atlassian/jira-issue-create-commons/src/common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '@atlassian/jira-issue-create-commons/src/common/utils/select/index.tsx';
import type { TransformedRole } from '@atlassian/jira-issue-field-role-picker/src/common/types.tsx';
import { RolePickerEdit } from '@atlassian/jira-issue-field-role-picker/src/ui/edit/index.tsx';
import messages from './messages.tsx';
import type { Props, FieldValue, IssueRestrictionFieldConfig } from './types.tsx';

const IssueRestrictionField = (props: Props) => {
	const { formatMessage } = useIntl();
	const {
		fieldProps: { value = [], onChange, ...fieldProps },
		selectedProject,
		error,
		autoFocus = false,
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		isMini,
		description,
		fieldName,
		width,
		ariaLabelledBy,
	} = props;
	const [shouldShowAccessWarning, setAccessWarningDisplay] = useState<boolean>(false);

	const convertToFieldType = (roles: TransformedRole[]): void => {
		onChange(roles.map(({ roleId }) => ({ roleId })));
	};
	return (
		<FieldContainer width={width}>
			<RolePickerEdit
				{...fieldProps}
				selectedProjectId={selectedProject?.value || ''}
				selectedRoles={value}
				onChange={convertToFieldType}
				autoFocus={autoFocus}
				isDisabled={false}
				classNamePrefix="issue-restriction-select"
				isInvalid={Boolean(error)}
				isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
				onCloseMenuOnScroll={onCloseMenuOnScroll}
				setAccessWarningDisplay={setAccessWarningDisplay}
				aria-labelledby={ariaLabelledBy}
			/>
			<FieldMessage description={description} error={error} fieldName={fieldName} isMini={isMini} />
			{shouldShowAccessWarning ? (
				<Box xcss={messageContainerStyles}>
					<SectionMessage appearance="warning">
						{formatMessage(
							expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
								? messages.noAccessOnIssueCreatedWarningIssueTermRefresh
								: messages.noAccessOnIssueCreatedWarning,
						)}
					</SectionMessage>
				</Box>
			) : null}
		</FieldContainer>
	);
};

export default withFormField({ shouldRenderFieldMessage: false })<
	IssueRestrictionFieldConfig,
	FieldValue
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<IssueRestrictionFieldConfig, FieldValue>, any>'.
>(IssueRestrictionField);

const messageContainerStyles = xcss({
	marginTop: 'space.050',
});
